import type { FaireProductEntity } from "../../entity_types/product";

export const p_a97qbqg7yq: FaireProductEntity = {
  token: "p_a97qbqg7yq",
  type: "product",
  name: "Luxury Adjustable Satin Sleep Eye Mask",
  brandName: "Funky Junque",
  imageUrl:
    "https://cdn.faire.com/fastly/1a0e92f3c0084cdda7074c015867ba77e3042f5b553e2286354e60c2c77038e5.jpeg",
  priceDollars: 3.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/06d7f4eaebaba61b66f169cc6197661016de7dcb085fe579f85cb7330780ade5.webp",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
